import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useGraphiQL } from "../provider.js";
/* empty css          */
const SidePanel = () => {
  const $ = c(2);
  const visiblePlugin = useGraphiQL(_temp);
  if (!visiblePlugin) {
    return null;
  }
  let t0;
  if ($[0] !== visiblePlugin) {
    t0 = /* @__PURE__ */ jsx(SidePanelView, { plugin: visiblePlugin });
    $[0] = visiblePlugin;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const SidePanelView = (t0) => {
  const $ = c(5);
  const {
    plugin
  } = t0;
  const Content = plugin.content;
  let t1;
  if ($[0] !== Content) {
    t1 = /* @__PURE__ */ jsx(Content, {});
    $[0] = Content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== plugin.title || $[3] !== t1) {
    t2 = /* @__PURE__ */ jsx("aside", { className: "graphiql-side-panel", "aria-label": plugin.title, children: t1 });
    $[2] = plugin.title;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(state) {
  return state.visiblePlugin;
}
export {
  SidePanel,
  SidePanelView
};
//# sourceMappingURL=index.js.map
